import * as React from 'react';

import {pillWrapper} from '../pill-wrapper';

import Svg from './quotes.svg';

type Props = {
    height?: number;
    width?: number;
};

function SvgComponent(props: Props) {
    return <Svg height={props.height} width={props.width} />;
}

export const QuotesPill = pillWrapper(SvgComponent);
